/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */
/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { translate } from "react-i18next";
import {
  Typography,
  TextField,
  Button,
  FormControl,
  FormHelperText,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { MIN_PASS_LENGTH } from "../../config";
import i18n from "../../services/i18n";
import STATIC_ROUTES from "../../route/STATIC_ROUTES";
import { isValidPassConfirm, isValidPassword } from "../../utils/validation";
import { checkPasswordExpiryService, resetPassword } from "../../services/auth";
import SINGUP_BACKGROUND from "../../assets/img/landing_main_background.png";
import { useNavigate } from "react-router";

const initialState = {
  pass: "",
  passConfirmation: "",
};

const ResetPassword = React.memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [state, setState] = useState(initialState);
  const [checkPasswordExpiry, setCheckPasswordExpiry] = useState();
  const [errorPassLength, setErrorPassLength] = useState(false);
  const [errorPassConfirm, setErrorPassConfirm] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const code = window.location.search.slice(7);

  async function checkPasswordService() {
    const findUser = await dispatch(checkPasswordExpiryService(code));
    if (findUser) {
      setCheckPasswordExpiry(true);
    } else {
      setCheckPasswordExpiry(false);
    }
  }

  // TODO: HERE IS THE PROBLEM!!!
  useEffect(() => {
    checkPasswordService();
  }, [dispatch]);

  function handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setState({
      ...state,
      [name]: value,
    });
  }

  async function validationData() {
    const { pass, passConfirmation } = state;
    const errorValidation = [];

    if (isValidPassword(pass)) {
      setErrorPassLength(false);
    } else {
      setErrorPassLength(true);
      errorValidation.push(true);
    }

    if (isValidPassConfirm(pass, passConfirmation, false)) {
      setErrorPassConfirm(false);
    } else {
      setErrorPassConfirm(true);
      errorValidation.push(true);
    }

    return errorValidation;
  }

  function keyPress(e) {
    if (e.key === "Enter") {
      resetPasswordHandler();
    }
  }

  async function resetPasswordHandler() {
    const data = {
      state,
      code: code,
    };
    const checkForErrors = await validationData();
    if (checkForErrors.length > 0) {
      return;
    }

    dispatch(resetPassword(data));
    navigate(STATIC_ROUTES.landingPage);
  }

  return (
    <div style={styles.root}>
      <Typography component="div" sx={styles.createToolPopup}>
        {checkPasswordExpiry && (
          <Typography component="h1">{i18n.t("core:passwordExpired")}</Typography>
        )}

        {!checkPasswordExpiry && (
          <Typography component="div">
            <FormControl fullWidth={true}>
              <TextField
                required
                id="layoutSignUpPassField"
                autoFocus={true}
                sx={styles.textField}
                label={i18n.t("core:password")}
                onChange={handleInputChange}
                name="pass"
                value={state.pass}
                type={showPassword ? "text" : "password"}
                margin="dense"
                variant="outlined"
                onKeyPress={keyPress}
                size="small"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        // onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <FormHelperText sx={{ display: "flex", flexDirection: "column" }}>
                To create a valid password, it is necessary to use a combination of at least 8
                characters, including both uppercase and lowercase letters, a number, and one of the
                special characters such as @, $, !, %, *, ?, or &. Using any other special
                characters besides these is not allowed.
              </FormHelperText>
              {errorPassLength && (
                <FormHelperText sx={styles.errorMessage}>
                  The password must meet the requirements!
                </FormHelperText>
              )}
            </FormControl>
            <FormControl fullWidth={true}>
              <TextField
                required
                id="layoutSignUpPassConfirmField"
                sx={styles.textField}
                label={i18n.t("core:confirmPassword")}
                onChange={handleInputChange}
                name="passConfirmation"
                value={state.passConfirmation}
                type={showConfirmPassword ? "text" : "password"}
                margin="dense"
                variant="outlined"
                onKeyPress={keyPress}
                size="small"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        edge="end"
                      >
                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {errorPassConfirm && (
                <FormHelperText sx={styles.errorMessage}>
                  Please make sure that you have entered the same password as in the previous field.
                </FormHelperText>
              )}
            </FormControl>

            <Typography component="div" sx={styles.alignSignUpButton}>
              <Button
                variant="contained"
                color="primary"
                sx={styles.singUpButton}
                onClick={resetPasswordHandler}
              >
                Save Changes
              </Button>
            </Typography>
          </Typography>
        )}
      </Typography>
    </div>
  );
});

export default translate(["core"], { wait: true })(ResetPassword);

const styles = {
  root: {
    minHeight: "750px",
    background: "#DDE5EF",
    overflowX: "hidden",
    overflowY: "hidden",
    padding: 20,
    backgroundImage: `url(${SINGUP_BACKGROUND})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    fontWeight: "300",
    minWidth: "500px",
  },
  createToolPopup: {
    background: "#fff",
    width: "30%",
    margin: "0px auto",
    marginTop: "130px",
    webkitBoxShadow: "0px 0px 5px 0px rgba(0,0,0,0.75)",
    mozBoxShadow: "0px 0px 5px 0px rgba(0,0,0,0.75)",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.75)",
    padding: "40px 35px 35px 35px",

    "& div": {
      // display: "block",
    },
  },
  textField: {
    "& input": {
      paddingLeft: "30px",
    },

    [`& fieldset`]: {
      borderRadius: 0,
    },
  },
  alignSignUpButton: {
    display: "flex",
    justifyContent: "right",
  },
  singUpButton: {
    marginTop: "25px",
  },
  personIcon: {
    position: "absolute",
    left: "10px",
    top: "10px",
  },
  errorMessage: {
    color: "red",
  },
};
